"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItem = void 0;
var MenuItem_1 = __importDefault(require("./MenuItem"));
exports.MenuItem = MenuItem_1.default;
exports.default = MenuItem_1.default;
//# sourceMappingURL=index.js.map